export const BASE_LAYER_KEY = {
    CITY: 'city',
    AREA: 'area',
    MSH: 'msh',
}

export const BSN_LAYER_KEY = {
    BSN: 'bsn',
    TEL: 'tel',
    FLOOD: 'flood'
}

export const BSN_TEL_LAYER_KEY = {
    BSN: 'bsn',
    TEL: 'tel'
}

export const RISK_ANALYSIS_LAYER_KEY = {
    BSN_H1: 'bsn_h1',
    BSN_H24: 'bsn_h24',
    BSN_H48: 'bsn_h48',
    BSN_OF: 'bsn_of',
    MSH_H1: 'msh_h1',
    MSH_H24: 'msh_h24',
    MSH_H48: 'msh_h48',
    MSH_RISK: 'msh_risk',
    MSH_SOIL: 'msh_soil',
}

export const ROAD_LAYER_KEY = {
    ROAD: 'road_line'
}

export const BASE_LAYER_LIST = [
    {
        category: BASE_LAYER_KEY.CITY,
        name: '市町村',
        index: 3
    },
    {
        category: BASE_LAYER_KEY.AREA,
        name: '字',
        index: 4
    },
    {
        category: BASE_LAYER_KEY.MSH,
        name: 'メッシュ',
        index: 6
    },
]

export const BSN_LAYER_LIST = [
    {
        category: BSN_LAYER_KEY.BSN,
        name: '河川',
    },
    {
        category: BSN_LAYER_KEY.TEL,
        name: '水位計',
    },
    {
        category: BSN_LAYER_KEY.FLOOD,
        name: '浸水区域',
    }
]

export const BSN_TEL_LAYER_LIST = [
    {
        category: BSN_TEL_LAYER_KEY.BSN,
        name: '河川',
    },
    {
        category: BSN_TEL_LAYER_KEY.TEL,
        name: '水位計',
    }
]

export const RISK_ANALYSIS_LAYER_LIST = [
    {
        category: RISK_ANALYSIS_LAYER_KEY.MSH_H1,
        name: '1時間雨量',
    },
    {
        category: RISK_ANALYSIS_LAYER_KEY.MSH_H24,
        name: '24時間雨量',
    },
    {
        category: RISK_ANALYSIS_LAYER_KEY.MSH_H48,
        name: '48時間雨量',
    },
    {
        category: RISK_ANALYSIS_LAYER_KEY.MSH_SOIL,
        name: '土壌雨量指数',
    },
    {
        category: RISK_ANALYSIS_LAYER_KEY.MSH_RISK,
        name: '土砂災害発生リスク',
    },
    {
        category: RISK_ANALYSIS_LAYER_KEY.BSN_H1,
        name: '流域平均1時間雨量',
    },
    {
        category: RISK_ANALYSIS_LAYER_KEY.BSN_H24,
        name: '流域平均24時間雨量',
    },
    {
        category: RISK_ANALYSIS_LAYER_KEY.BSN_H48,
        name: '流域平均48時間雨量',
    },
    {
        category: RISK_ANALYSIS_LAYER_KEY.BSN_OF,
        name: '流域平均流出量',
    },
]

export const ROAD_LAYER_LIST = [
    {
        category: ROAD_LAYER_KEY.ROAD,
        name: '道路',
    }
]

export const HAZARD_LAYER_KEY = {
    NONE: 'none',
    FLOOD: 'flood',
    INLAND_FLOOD: 'inland_flood',
    LANDSLIDE: 'landslide',
    LANDSLIDE_DEBRIS_FLOW: 'landslide_debris_flow',
    LANDSLIDE_SLEEP_SLOPE: 'landslide_steep_slope',
}

export const HAZARD_LAYER_LIST = [
    {
        category: HAZARD_LAYER_KEY.NONE,
        name: '非表示',
    },
    {
        category: HAZARD_LAYER_KEY.FLOOD,
        name: '洪水浸水想定区域',
    },
    {
        category: HAZARD_LAYER_KEY.INLAND_FLOOD,
        name: '内水浸水想定区域',
    },
    {
        category: HAZARD_LAYER_KEY.LANDSLIDE,
        name: '土砂警(地滑り)',
    },
    {
        category: HAZARD_LAYER_KEY.LANDSLIDE_DEBRIS_FLOW,
        name: '土砂警(土石流)',
    },
    {
        category: HAZARD_LAYER_KEY.LANDSLIDE_SLEEP_SLOPE,
        name: '土砂警(急傾斜地の崩壊)',
    },
]

export const DRONE_SHARING_LAYER_KEY = {
    LANDSLIDE: 'landslide',
    FLOOD: 'flood',
    TSUNAMI: 'tsunami'
}

export const DRONE_SHARING_LAYER_LIST = [
    {
        category: DRONE_SHARING_LAYER_KEY.LANDSLIDE,
        name: '土砂災害警戒区域等',
    },
    {
        category: DRONE_SHARING_LAYER_KEY.FLOOD,
        name: '洪水浸水想定区域',
    },
    {
        category: DRONE_SHARING_LAYER_KEY.TSUNAMI,
        name: '津波浸水想定',
    }
]